import * as React from 'react'

function SvgCopyToClipboard(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M25 11.25H13.75a2.5 2.5 0 00-2.5 2.5V25a2.5 2.5 0 002.5 2.5H25a2.5 2.5 0 002.5-2.5V13.75a2.5 2.5 0 00-2.5-2.5z"
        stroke={props.color || 'currentColor'}
        strokeWidth={3}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.25 18.75H5a2.5 2.5 0 01-2.5-2.5V5A2.5 2.5 0 015 2.5h11.25a2.5 2.5 0 012.5 2.5v1.25"
        stroke={props.color || 'currentColor'}
        strokeWidth={3}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default SvgCopyToClipboard
